import { IMAGE_MODAL_ACTION, SNACKBAR_ACTION } from "./root.actions";
import ReducerFactory from "../reducer-factory";
import { IImageModal, ISnackbar } from "../../types";

export interface IRootState {
  snackbar: ISnackbar;
  imageModal: IImageModal;
}

export const initState: IRootState = {
  snackbar: {
    open: false,
    message: "",
    type: "default",
  },
  imageModal: {
    open: false,
    url: "",
  },
};

const reducer = new ReducerFactory<IRootState>(initState)
  .add(SNACKBAR_ACTION, (state, action) => {
    return {
      ...state,
      snackbar: action.payload,
    };
  })
  .add(IMAGE_MODAL_ACTION, (state, action) => {
    return {
      ...state,
      imageModal: action.payload,
    };
  })
  .toReducer();

export default reducer;
